
import { createStore, compose, applyMiddleware } from 'redux';
import {persistStore} from "redux-persist"
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga';
import {routerMiddleware} from "connected-react-router";
import rootSaga from './saga';
import rootReducer from './combinedReducers';
import { createBrowserHistory } from 'history'
export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();
// const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || compose;

const middlewares = [ sagaMiddleware,routerMiddleware(history) ]; // Push other middlewares here

const configureStore = (initialState = {}) => {
  const store = createStore(
    rootReducer(history),
    initialState,
    composeWithDevTools(applyMiddleware(...middlewares)),
  );

  sagaMiddleware.run(rootSaga);

  return store;
};



export const store = configureStore();
export const persistor = persistStore(store)
export default configureStore;